function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m280 168h16v16h-16zm0 0"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m114.519531 264c2.414063 5.058594 4.042969 10.453125 4.839844 16h10.242187c-1.070312-5.265625-1.609374-10.625-1.601562-16zm0 0"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m64 104v-8c.027344-26.5 21.5-47.972656 48-48h49.960938l11.429687-40h-170.78125l27.429687 96zm0 0"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m272 8c0-4.417969-3.582031-8-8-8s-8 3.582031-8 8v8h16zm0 0"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m200 184.40625v-88.40625c0-4.417969 3.582031-8 8-8h90.71875c3.8125-.015625 7.449219-1.589844 10.066406-4.359375 2.183594-2.226563 3.34375-5.261719 3.199219-8.375-.164063-2.929687-1.40625-5.695313-3.480469-7.769531-2.261718-2.242188-5.320312-3.5-8.503906-3.496094h-28v16h-16v-16h-144c-14.546875.054688-27.226562 9.914062-30.863281 24h102.863281v16h-104v97.601562c17.25 3.027344 33.164062 11.257813 45.601562 23.589844l-11.203124 11.457032c-3.203126-3.140626-6.683594-5.984376-10.398438-8.496094v19.847656h25.601562c7.058594-34.296875 35.5625-60.042969 70.398438-63.59375zm0 0"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m64 248c-22.089844 0-40 17.910156-40 40s17.910156 40 40 40 40-17.910156 40-40c-.027344-22.082031-17.917969-39.972656-40-40zm0 64c-13.253906 0-24-10.746094-24-24s10.746094-24 24-24 24 10.746094 24 24-10.746094 24-24 24zm0 0"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "m40 220.230469v17.25c15.164062-7.308594 32.835938-7.308594 48 0v-17.304688c-15.542969-5.4375-32.472656-5.417969-48 .054688zm0 0"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "m64 200.046875v-80.046875h-64v16h48v16h-48v44.6875l17.015625 17.015625c14.023437-8.976563 30.335937-13.71875 46.984375-13.65625zm0 0"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "m72 288c0 4.417969-3.582031 8-8 8s-8-3.582031-8-8 3.582031-8 8-8 8 3.582031 8 8zm0 0"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "m208 232c-17.671875 0-32 14.328125-32 32s14.328125 32 32 32 32-14.328125 32-32-14.328125-32-32-32zm8 40h-16v-16h16zm0 0"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "m288 264c.007812 5.375-.53125 10.734375-1.601562 16h33.203124c-2.546874-5.085938-4.476562-10.457031-5.746093-16zm0 0"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "m272 200c-4.417969 0-8-3.582031-8-8v-24h-48v16.40625c23.421875 2.375 44.609375 14.945312 57.921875 34.363281l18.765625-18.769531zm0 0"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "m286.9375 104h-38.9375v48h32.9375zm0 0"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "m366.34375 230.34375c9.878906-9.441406 25.433594-9.441406 35.3125 0l35.351562 35.351562c8.429688-24.839843-1.367187-52.214843-23.644531-66.066406-22.277343-13.851562-51.164062-10.527344-69.710937 8.023438-18.550782 18.546875-21.875 47.433594-8.023438 69.710937 13.851563 22.277344 41.226563 32.074219 66.066406 23.644531l-35.351562-35.351562c-9.734375-9.757812-9.734375-25.554688 0-35.3125zm0 0"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "m208 200c-35.347656 0-64 28.652344-64 64s28.652344 64 64 64 64-28.652344 64-64c-.039062-35.328125-28.671875-63.960938-64-64zm0 112c-26.507812 0-48-21.492188-48-48s21.492188-48 48-48 48 21.492188 48 48c-.027344 26.5-21.5 47.972656-48 48zm0 0"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "m390.34375 241.65625c-3.550781-3.390625-9.136719-3.390625-12.6875 0-3.488281 3.511719-3.488281 9.175781 0 12.6875l57.65625 57.65625h12.6875v-12.6875zm0 0"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "m216 104h16v48h-16zm0 0"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "m256 24h16v40h-16zm0 0"
});

var SvgImplementos = function SvgImplementos(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "448pt",
    viewBox: "0 -60 448 448",
    width: "448pt",
    x: "0px",
    y: "0px",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgImplementos, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/implementos.ea15a4c5.svg";
export { ForwardRef as ReactComponent };